module.exports = __webpack_public_path__ + "static/media/WHERE DO WE GO FROM HERE.388e6bf1.png";